import axios from 'axios'
import { BillableRateWithConceptInformationResponse } from '@/api/services/billing/common-billable-rate/billing-common-billable-rate.dto'

class BillingCommonBillableRateService {
    async getActiveBillableRates(
        laboratoryId: number,
        billableConceptId: number,
        customerId?: number
    ): Promise<BillableRateWithConceptInformationResponse[]> {
        const response =
            await axios.get<BillableRateWithConceptInformationResponse[]>(
                `/billing/laboratories/${laboratoryId}/billableRates`,
                {
                    params: {
                        billableConceptId,
                        customerId
                    }
                })
        return response.data
    }
}
export const billingCommonBillableRateService = new BillingCommonBillableRateService()
